import React, {useRef, useState} from 'react';
import Form, {FormInputComponent} from "../../../components/form/Form";
import {useOpportunity} from "../../../providers/OpportunityProvider";

const TalentReleventExpEditTab = ({opportunity, editable = true}) => {
    const {
        isDisabled,
        onUpdate,
    } = useOpportunity();

    const formRef = useRef(null);

    const [formId, setFormId] = useState(1);
    const fieldProps = ['relevant_experience']

    const [formModel, setFormModel] = useState(TB.pick(opportunity?.job_candidate || {}, fieldProps));

    const hasAccessToEdit = opportunity.canAdmin() || opportunity.isProposingAsIndividual()

    const mapping = (model) => {
            // model.relevant_experience = model.relevant_experience || '';
        return model;
    }

    const hasFormModelChanged = () => {
        let opp = mapping( TB.pick(opportunity?.job_candidate || {}, fieldProps));
        let model = mapping(TB.pick(formModel, fieldProps))
        return !TB.isEqual(opp, model)
    }

    const resetForm = async() => {
        let model = TB.pick(opportunity?.job_candidate || {}, fieldProps)

        model = mapping(model);

        await formRef.current.forceReset(model);
        await formRef.current.formRef.current.formsyForm.setFormPristine(true);
        await setFormModel(model)
        await setFormId(formId+1)
    }

    const submitForm = async() => {
        let invalid = formRef.current.forceValidate(formModel);
        if (invalid) {
            return;
        }
        let success = await onUpdate({job_candidate: formModel}, opportunity)

    }
    return (
        <React.Fragment>
            <div className="opp-talent-proposal-form">
                <Form
                    ref={formRef}
                    key={formId}
                    background={"transparent"}
                    mapping={mapping}
                    onSubmit={submitForm}
                    submitButton={false}
                    isDisabled={isDisabled}
                    model={formModel}
                    fields={[]}
                    className={TB.mapClass({'no-edit': !editable})}
                    onChange={model => setFormModel({
                        ...formModel, ...model
                    })}>

                    <div className="lg:flex flex-row items-center my-2">
                        <p className="proposal-tab-subheader mb-0 mt-0">
                            Highlight your talent's specific experience based on the client request
                        </p>
                    </div>
                    <div className="field-section flex-row">
                        <div className="field px-3.5 basis-10/12">
                            <FormInputComponent
                                fieldName="relevant_experience"
                                value={formModel.relevant_experience}
                                label={false}
                                placeholder="Enter relevant experience..."
                                type={'editor'}
                                required={false}
                                style={styles.field}
                                maxLength={10000}
                                validation={{
                                    rules: {maxLength: 10000},
                                    errors: {
                                        maxLength: TB.trans('validation.max.string', {
                                            'attribute': 'relevant experience',
                                            'max': 10000
                                        })
                                    }
                                }}
                                enableScroll={true}
                            />

                        </div>
                    </div>
                    {hasAccessToEdit && editable && (
                        <div className="mt-3 flex flex-row justify-end">
                            <button type="submit" className="btn btn-primary mr-3"
                                    disabled={isDisabled || !hasFormModelChanged()}>
                                Save
                            </button>
                            <button className="btn btn-outline-dark"
                                    type="button" onClick={resetForm}
                                    disabled={isDisabled || !hasFormModelChanged()}>
                                Cancel
                            </button>
                        </div>
                    )}
                </Form>
            </div>

        </React.Fragment>
    );
};

const styles = {
    fieldSectionCol: {
        flexDirection: 'column',
        alignItems: 'stretch'
    },
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: 0,
    },
    rowField: {padding: '0 15px', marginBottom: 0}
};


export default TalentReleventExpEditTab;